module.exports = __webpack_public_path__ + "static/media/chain-active.76c0e5d1.png";